<template>
  <div style="background-color: #1C1632">
    <div class="earn-rewards-container">
      <div class="title">YOU EARN, WE REWARD!</div>
      <div class="cards-wrapper">
        <div class="cards">
          <div class="card">
            <h1>500%</h1>
            <h2>Refer Friends Today!</h2>
            <p>Just share with friends, invite them to join, and enjoy the extra commission or bet to win more!</p>
            <button>Learn More</button>
          </div>
          <div class="card">
            <h1>500%</h1>
            <h2>Refer Friends Today!</h2>
            <p>Just share with friends, invite them to join, and enjoy the extra commission or bet to win more!</p>
            <button>Learn More</button>
          </div>
          <div class="card">
            <h1>500%</h1>
            <h2>Refer Friends Today!</h2>
            <p>Just share with friends, invite them to join, and enjoy the extra commission or bet to win more!</p>
            <button>Learn More</button>
          </div>
          <div class="card">
            <h1>500%</h1>
            <h2>Refer Friends Today!</h2>
            <p>Just share with friends,enjoy the extra commission or bet to win more!</p>
            <button>Learn More</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'appEarnRewards',
}
</script>

<style lang="scss">
.earn-rewards-container {
  max-width: 1240px;
  margin: auto;
  padding: 20px;

  .title {
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 20px;
    color: white;
  }

  .cards-wrapper {
    overflow-x: auto;
    scroll-snap-type: x mandatory;
    -webkit-overflow-scrolling: touch;
  }

  .cards {
    display: flex;
    gap: 16px;
    white-space: nowrap;
    padding-bottom: 10px;
    width: max-content;
  }

  .card {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    background: linear-gradient(to bottom, #22062C, #7D0087);
    padding: 20px;
    border-radius: 10px;
    text-align: center;
    width: 260px;
    height: 320px;
    flex-shrink: 0;
    border: 1px solid #413275;
  }

  .card h1 {
    font-size: 50px;
    font-weight: bold;
    color: #FFCC00;
    text-shadow: 2px 2px 5px rgba(255, 165, 0, 0.8);
  }

  .card h2 {
    font-size: 18px;
    color: #FFC107;
    font-weight: bold;
    margin-bottom: 10px;
  }

  .card p {
    flex-grow: 1; // 让 `p` 占满剩余空间，把 `button` 推到最底部

    font-size: 14px;
    color: white;
    max-width: 100%;
    word-wrap: break-word;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
  }

  .card button {
    margin-top: 15px;
    background: #FFC000;
    color: black;
    border: none;
    padding: 10px 20px;
    border-radius: 5px;
    font-size: 16px;
    font-weight: bold;
    cursor: pointer;
    width: 100%;
    touch-action: manipulation;
  }

  .card button:hover {
    background: #FF9800;
  }
}
</style>
